import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    FamilyRestroom,
    CheckCircle,
    HighlightOff,
    Gavel,
    Star,
    AccountCircle,
    ThumbUpAlt,
    WarningAmber,
    EmojiPeople,
    Home,
    MenuBook,
    ChatBubbleOutline
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで家族と住むという選択肢
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('features')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    家族ルームシェアの特徴とは？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('merits-demerits')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    メリット・デメリット
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('rulemaking')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    快適に暮らすためのルール作り
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experiences')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際の体験談
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.15rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで家族と住むという選択肢
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアといえば、友人や初対面の他人同士が一つ屋根の下で暮らすイメージが強いですが、近年では「家族」とのルームシェアも広がりを見せています。親子・兄弟姉妹・パートナー・親戚など、親しい関係だからこそ感じる安心感や、逆に気をつけたいポイントも多いもの。<br />
                    本記事では、<Chip label="家族ルームシェア" color="primary" variant="outlined" sx={{ mx: 0.5 }} />ならではの特徴や、メリット・デメリット、円満に暮らすためのルール作りのコツ、そして実際の体験談まで、分かりやすく解説します。
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    家族とのルームシェアは、他人とのシェアとは異なる独特の課題と豊かな魅力があります。
                </Typography>
            </Box>

            {/* 特徴 */}
            <Box id="features" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    家族ルームシェアの特徴とは？
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <FamilyRestroom color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    家族だからこその「安心感」と「距離感」
                                </Typography>
                            </Box>
                            <Typography variant="body1">
                                家族同士でのルームシェアは、信頼感がベースにあるため「生活リズムのすり合わせがしやすい」「遠慮しすぎないで済む」など、他人同士にはない安心感があります。一方で、気心が知れている分、プライベートの線引きが曖昧になりやすい点には注意が必要です。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Home color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    多様な家族形態に対応
                                </Typography>
                            </Box>
                            <Typography variant="body1">
                                家族ルームシェアには、親子・兄弟姉妹・パートナー・従兄弟など、さまざまなパターンがあります。それぞれの関係性やライフステージによって、最適な距離感や暮らし方が異なります。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2 }}>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <MenuBook color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                        生活習慣・価値観の共有がしやすい
                                    </Typography>
                                }
                                secondary="子どものころからの習慣や家族特有のルールがあることで、ストレスなく共同生活を始めやすいです。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ChatBubbleOutline color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                        コミュニケーションがスムーズ
                                    </Typography>
                                }
                                secondary="意思疎通がしやすい反面、遠慮や配慮を忘れがちなので、意識して会話の質を高める必要も。"
                            />
                        </ListItem>
                    </List>
                </Box>
            </Box>

            {/* メリット・デメリット */}
            <Box id="merits-demerits" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    メリット・デメリット
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ThumbUpAlt color="success" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>メリット</Typography>
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircle color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="安心感とセーフティネット"
                                        secondary="困ったときに助け合えるので、特に子育て世帯や高齢者にもおすすめです。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircle color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="費用の節約"
                                        secondary="家賃・光熱費・食費などを分担でき、経済的なメリットが得られます。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircle color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="生活の柔軟性"
                                        secondary="子どもの成長や家族構成の変化に合わせて部屋割りや生活スタイルを調整しやすいです。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircle color="success" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="心理的な安心"
                                        secondary="孤独感や不安を感じにくく、精神的なサポートを得やすいです。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <WarningAmber color="error" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>デメリット</Typography>
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <HighlightOff color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="プライバシーの確保が難しい"
                                        secondary="家族だからこそ、個人の時間や空間を尊重する意識が薄れやすい傾向があります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <HighlightOff color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="役割分担の偏り"
                                        secondary="家事や育児、金銭面などで、無意識に負担が偏ってしまう場合があります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <HighlightOff color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="衝突がエスカレートしやすい"
                                        secondary="親密な関係ゆえに感情的なぶつかり合いが起こりやすく、長引くとストレスの原因に。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <HighlightOff color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="外部との距離が生まれることも"
                                        secondary="家族だけで閉じたコミュニティになりやすく、他の交友関係が希薄になることも。"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    メリット・デメリットを家族でしっかり話し合うことが、円満なルームシェアの第一歩です。
                </Typography>
            </Box>

            {/* ルール作り */}
            <Box id="rulemaking" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    快適に暮らすためのルール作り
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={2} sx={{ p: 3, mb: 2, bgcolor: '#fafafa', borderRadius: 2 }}>
                    <Typography variant="h6" color="primary" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                        <Gavel sx={{ mr: 1 }} />
                        ルール作りのポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="プライベートな空間・時間の尊重"
                                secondary="部屋や時間帯ごとに『立ち入り禁止』や『ノック』などのルールを設けて、お互いのプライバシーを守りましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="家事・役割分担の明確化"
                                secondary="家事や買い物、ゴミ出しなど、誰が何を担当するかを具体的に決めておくことで、不満やトラブルの防止につながります。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="お金の管理方法"
                                secondary="家賃・光熱費・食費など、共同で支払う費用は家族会議で分担方法を決めて、記録も残しておきましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="定期的なコミュニケーション"
                                secondary="月1回の「家族ミーティング」など、気軽に話し合える場を設けて、小さな問題も早期に解決しましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary="お互いのライフスタイルへの配慮"
                                secondary="生活リズムや趣味・交友関係の違いを認め合い、干渉しすぎない距離感を意識することも大切です。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Box
                    component="img"
                    src="/images/blog/family-meeting_roomshare-family-caution.jpg"
                    alt="日曜日の朝、明るいダイニングで家族全員が集まり、ノートやタブレットを使って住まいのルールや家事分担について活発に話し合っているシーン。和やかで協力的な雰囲気"
                    sx={{ width: '100%', borderRadius: 2, mt: 3, mb: 1, boxShadow: 1 }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    家族会議を定期的に開くことで、ルールの見直しやお互いの気持ちを確認する機会を持ちましょう。
                </Typography>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                        チェックポイント
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <Chip icon={<CheckCircle color="success" />} label="ルールは見える化" variant="outlined" color="primary" sx={{ mb: 1, mr: 1 }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Chip icon={<CheckCircle color="success" />} label="役割分担表を作る" variant="outlined" color="primary" sx={{ mb: 1, mr: 1 }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Chip icon={<CheckCircle color="success" />} label="月1の家族会議" variant="outlined" color="primary" sx={{ mb: 1, mr: 1 }} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Chip icon={<CheckCircle color="success" />} label="費用精算はアプリ活用" variant="outlined" color="primary" sx={{ mb: 1, mr: 1 }} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* 体験談 */}
            <Box id="experiences" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際の体験談
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar sx={{ bgcolor: '#1976d2', mr: 1 }}>
                                        <AccountCircle />
                                    </Avatar>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        20代女性・姉妹シェア
                                    </Typography>
                                </Box>
                                <Typography variant="body2">
                                    「社会人になってから妹と2人でルームシェアを始めました。家事分担表をアプリで管理することで、お互いの負担感が減り、ケンカも激減。定期的に『何か困ってることない？』と声をかけ合うようにしています。」
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar sx={{ bgcolor: '#43a047', mr: 1 }}>
                                        <AccountCircle />
                                    </Avatar>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        30代男性・親子シェア
                                    </Typography>
                                </Box>
                                <Typography variant="body2">
                                    「母と二人暮らしですが、家計簿アプリで費用を分担し、毎月ルールの見直しをしています。最初は遠慮がちでしたが、ルール化することでお互いに気を使いすぎず、快適に過ごせるようになりました。」
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

            </Box>

            {/* まとめ・アドバイス */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとアドバイス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    家族とのルームシェアは、安心感や経済的メリットが大きい一方、プライバシーや役割分担など独特の課題もあります。<br />
                    円満な共同生活のためには「家族だから」と甘えず、<b>ルール作り</b>と<b>定期的な話し合い</b>を大切にしましょう。
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <EmojiPeople color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="お互いの違いを認め合う"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <EmojiPeople color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="小さなことでも相談・共有"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <EmojiPeople color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="家族だけで抱え込まず、外部とのつながりも大切に"
                        />
                    </ListItem>
                </List>
                <Box sx={{ mt: 1, mb: 3 }}>
                    <Paper elevation={0} sx={{ p: 2, bgcolor: '#e3f2fd', borderLeft: '5px solid #1976d2', borderRadius: 1 }}>
                        <Typography variant="body2" color="primary">
                            ルームシェアは、家族の新しい関係性を築く絶好のチャンス。お互いへの思いやりと工夫で、より豊かな暮らしを実現しましょう。
                        </Typography>
                    </Paper>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-family-caution',
    slug: 'roomshare-family-caution',
    title: 'ルームシェアで「家族」と住む場合の注意点',
    excerpt: '家族ルームシェアの特徴・メリット・デメリット、ルール作りのコツやリアルな体験談まで、安心で快適な家族シェア生活のポイントを専門的に分かりやすく解説します。',
    coverImage: '/images/blog/cover-roomshare-family_roomshare-family-caution.jpg',
    coverImageAlt: '明るい窓から自然光が差し込むモダンなルームシェアのリビングで、家族がそれぞれリラックスしつつも心地よい距離感で過ごし、会話や団らんを楽しんでいる様子。木目調のテーブルやカラフルなクッションが温かみを添えており、家族ルームシェアの安心感と快適さ、現代的な暮らしの雰囲気を象徴的に表現している。',
    publishedAt: '2024-06-17T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '家族', '暮らし方'],
    tags: ['家族ルームシェア', 'ルール作り', 'メリットデメリット'],
    author: {
        name: '山本 彩乃',
        avatar: '/images/avatars/ayano-yamamoto.jpg',
        bio: 'ルームシェア歴10年以上。実体験と最新の住まいトレンドをもとに、安心で快適なシェア生活のノウハウを発信中。多様な家族や世代のシェア事例にも精通。',
        profilePicture: '/images/avatars/ayano-yamamoto.jpg'
    },
    viewCount: 1432,
    contentComponent: PostContent
};

export default post;